import { Link } from "react-router-dom";
import Seo from "@/components/feature/Seo";

export default function NotFound() {
  return (
    <>
      <Seo
        title="页面未找到｜深田咏美资讯"
        description="您访问的页面不存在或已下线，请返回首页或使用全站搜索查找深田咏美的相关内容。"
      />
      <section className="flex min-h-[60vh] items-center justify-center bg-background-50 px-4 py-20">
        <div className="max-w-lg text-center">
          <p className="font-heading text-7xl font-black text-primary-500 md:text-9xl">404</p>
          <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            抱歉，页面找不到了
          </h1>
          <p className="mt-3 text-sm leading-relaxed text-foreground-500">
            你访问的链接可能已失效或内容已被移动。不妨回到首页，或去新闻中心与作品库看看最新的内容。
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
            >
              <i className="ri-home-4-line"></i>
              返回首页
            </Link>
            <Link
              to="/search"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-semibold text-foreground-700 transition-colors hover:bg-background-100 cursor-pointer"
            >
              <i className="ri-search-line"></i>
              全站搜索
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}